import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useLegalProceedingsProcessData } from './hook';
import { LegalProceedingsProcessDataProps } from './props';
import dayjs from 'dayjs';
import DatePickerField from '../../../../../components/general/fields/datePickerField';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const LegalProceedingsProcessData = (
    props: LegalProceedingsProcessDataProps
) => {
    const {
        formik,
        statusList,
        processesList,
        entitiesList,
        issuesList,
        locations,
    } = useLegalProceedingsProcessData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de recepción"
                    name="dateReceipt"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    required
                    touched={formik.touched.dateReceipt}
                    errors={formik.errors.dateReceipt?.toString()}
                    value={
                        formik.values.dateReceipt
                            ? dayjs(formik.values.dateReceipt)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'dateReceipt',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Radicado compañia"
                    name="registeredCompany"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.registeredCompany}
                    errors={formik.errors.registeredCompany}
                    value={formik.values.registeredCompany}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Documento accionante"
                    name="documentClaimant"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.documentClaimant}
                    errors={formik.errors.documentClaimant}
                    value={formik.values.documentClaimant}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre accionante"
                    name="nameClaimant"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.nameClaimant}
                    errors={formik.errors.nameClaimant}
                    value={formik.values.nameClaimant}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Documento accionado"
                    name="documentProcessed"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.documentProcessed}
                    errors={formik.errors.documentProcessed}
                    value={formik.values.documentProcessed}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre accionado"
                    name="nameProcessed"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.nameProcessed}
                    errors={formik.errors.nameProcessed}
                    value={formik.values.nameProcessed}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Documento asegurado"
                    name="insuredDocument"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.insuredDocument}
                    errors={formik.errors.insuredDocument}
                    value={formik.values.insuredDocument}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre asegurado"
                    name="insuredName"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.insuredName}
                    errors={formik.errors.insuredName}
                    value={formik.values.insuredName}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número requerimiento"
                    name="requirementNumber"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.requirementNumber}
                    errors={formik.errors.requirementNumber}
                    value={formik.values.requirementNumber}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número expediente"
                    name="fileNumber"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.fileNumber}
                    errors={formik.errors.fileNumber}
                    value={formik.values.fileNumber}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre persona subscribe"
                    name="namePersonSubscribe"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.namePersonSubscribe}
                    errors={formik.errors.namePersonSubscribe}
                    value={formik.values.namePersonSubscribe}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Póliza"
                    name="policy"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.policy}
                    errors={formik.errors.policy}
                    value={formik.values.policy}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Email remitente"
                    name="senderEmail"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.senderEmail}
                    errors={formik.errors.senderEmail}
                    value={formik.values.senderEmail}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Placa"
                    name="plate"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.plate}
                    errors={formik.errors.plate}
                    value={formik.values.plate}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de vencimiento"
                    name="expirationDate"
                    size="small"
                    touched={formik.touched.expirationDate}
                    errors={formik.errors.expirationDate?.toString()}
                    value={
                        formik.values.expirationDate
                            ? dayjs(formik.values.expirationDate)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'expirationDate',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(processesList)}
                    label="Proc. Judiciales"
                    name="legalProceedings"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.legalProceedings}
                    errors={formik.errors.legalProceedings}
                    value={formik.values.legalProceedings}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('legalProceedings', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="PQR identificada"
                    name="pqrIdentified"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.pqrIdentified}
                    errors={formik.errors.pqrIdentified}
                    value={formik.values.pqrIdentified}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(entitiesList)}
                    label="Entidad remitente"
                    name="submittingEntity"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.submittingEntity}
                    errors={formik.errors.submittingEntity}
                    value={formik.values.submittingEntity}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('submittingEntity', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Dirección"
                    name="address"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.address}
                    errors={formik.errors.address}
                    value={formik.values.address}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(statusList)}
                    label="Estado"
                    name="status"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(issuesList)}
                    label="Asunto"
                    name="subject"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.subject}
                    errors={formik.errors.subject}
                    value={formik.values.subject}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('subject', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(locations)}
                    label="Ubicación"
                    name="location"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.location}
                    errors={formik.errors.location}
                    value={formik.values.location}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('location', value)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Tema/Detalle"
                    name="detail"
                    rows={5}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.detail}
                    errors={formik.errors.detail}
                    value={formik.values.detail}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
